
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[contract]/[token]",
      function () {
        return require("private-next-pages/[contract]/[token].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[contract]/[token]"])
      });
    }
  